module.exports = __webpack_public_path__ + "img/icone-rice.47b16392.svg";